import gql from 'graphql-tag'

export const GET_COIN_RATE_GROUPS_QUERY = gql`
	query(
		$skip: Int!
		$take: Int!
		$orderBy: [OrderByInput!]
	) {
		getCoinsRateGroups(
			data: { orderBy: $orderBy, pagination: { skip: $skip, take: $take } }
		) {
			items {
				id
				createdAt
				fromDate
				rates {
					id
					currencyTitle
					currency {
						title
						symbol
						main
					}
					value
				}
			}
			total
			hasMore
		}
	}
`;

export const GET_COIN_RATE_GROUP_EXTRA_QUERY = gql`
  query {
    getAllCurrencies {
      title
      symbol
      left
			main
    }
		getCurrentCoinsRateGroup {
			id
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
  }
`;
